import { useContext } from "react";
import BrandsContext from "../context/BrandsProvider";

const useDataBrands = () => {
    return useContext(BrandsContext)
}

export default useDataBrands